var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00031 3.0621C7.27391 2.39417 6.32312 2.02347 5.33631 2.02344C4.81401 2.02398 4.29696 2.12781 3.81494 2.32895C3.33291 2.53009 2.89542 2.82457 2.52765 3.19544C0.958979 4.77077 0.959646 7.23477 2.52898 8.80344L7.41698 13.6914C7.53031 13.8908 7.74898 14.0194 8.00031 14.0194C8.10351 14.0184 8.20504 13.9932 8.29674 13.9459C8.38844 13.8985 8.46775 13.8303 8.52831 13.7468L13.4716 8.80344C15.041 7.2341 15.041 4.77077 13.4703 3.19277C13.1027 2.82258 12.6656 2.5287 12.184 2.32803C11.7025 2.12735 11.186 2.02384 10.6643 2.02344C9.67753 2.0236 8.72678 2.39429 8.00031 3.0621V3.0621ZM12.5276 4.13544C13.5696 5.18277 13.5703 6.81877 12.529 7.86077L8.00031 12.3894L3.47165 7.86077C2.43031 6.81877 2.43098 5.18277 3.47031 4.1381C3.97698 3.6341 4.63965 3.35677 5.33631 3.35677C6.03298 3.35677 6.69298 3.6341 7.19565 4.13677L7.52898 4.4701C7.59084 4.53207 7.66431 4.58123 7.74518 4.61477C7.82606 4.64831 7.91276 4.66557 8.00031 4.66557C8.08787 4.66557 8.17457 4.64831 8.25544 4.61477C8.33632 4.58123 8.40979 4.53207 8.47165 4.4701L8.80498 4.13677C9.81298 3.13077 11.521 3.13344 12.5276 4.13544V4.13544Z",
    fill: "#CED4DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxHeart);
export default __webpack_public_path__ + "static/media/bx-heart.42992f3efb9f825cca620d95e9731890.svg";
export { ForwardRef as ReactComponent };